import { render, staticRenderFns } from "./new_bis.vue?vue&type=template&id=1f34f3f5"
import script from "./new_bis.vue?vue&type=script&lang=ts"
export * from "./new_bis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports